module.exports = __webpack_public_path__ + "static/media/RussoOne-Regular.8a511841.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/RussoOne-Regular.ttf
// module id = 6688
// module chunks = 2